<template>
  <section>
    <h1>{{$t('categories.title')}}</h1>
    <vs-row vs-justify="left" vs-align="left">
      <vs-col vs-offset="1" vs-type="flex" vs-w="10">
        <vs-button color="primary" @click="create">{{$t('common.new')}}</vs-button>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-offset="1" vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
        <vs-list>
          <vs-list-item v-for="category in categories" :key="category.id" :title="category.name">
            <template slot="avatar">
              <img class="category-avatar" v-if="category.avatar && category.avatar.length" :src="category.avatar"/>
              <vs-avatar v-if="!category.avatar || !category.avatar.length"/>
            </template>
            <vs-button color="warning" @click="modify(category)">{{$t('common.edit')}}</vs-button>
            <vs-button color="danger" @click="del(category)">{{$t('common.delete')}}</vs-button>
          </vs-list-item>
        </vs-list>
      </vs-col>
    </vs-row>
    <vs-popup class="edit" :title="$t('common.edit')" :active.sync="editPopupActive">
      <vs-row>
        <vs-col vs-w="4">
          <vs-image v-if="category.avatar && category.avatar.length" :src="category.avatar"/>
          <vs-upload
            :single-upload="true"
            class="uploader"
            fileName="avatar"
            limit="1"
            :headers="headers"
            :action="getUploadAPI()"
            @on-success="uploaded"
          />
        </vs-col>
        <vs-col vs-w="8">
          <vs-input
            class="input-name"
            :label="$t('categories.name')"
            placeholder="Ex : Décoration"
            v-model="category.name"
          />
        </vs-col>
      </vs-row>
      <vs-row class="save">
        <vs-button color="success" @click="save">{{$t('common.save')}}</vs-button>
      </vs-row>
    </vs-popup>
  </section>
</template>

<script>
const { VUE_APP_API_HOST } = process.env
import Categories from '../mixins/Categories.vue'

export default {
  name: 'categories',

  mixins: [Categories],

  data: () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem('user-token')}`
    },
    editPopupActive: false,
    categories: [],
    category: {
      name: '',
      avatar: ''
    }
  }),

  beforeMount() {
    this.$vs.loading({ color: 'primary' })
    this.list()
  },

  methods: {
    getUploadAPI() {
      return `${VUE_APP_API_HOST}/categories/avatar`
    },
    closeEdition(){
      this.category = { name: '', avatar: '' }
      this.editPopupActive = false
    },
    create() {
      this.category = { name: '', avatar: '' }
      this.editPopupActive = true
    },
    modify(category) {
      this.category = category
      this.editPopupActive = true
    },
    del(category) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('common.warn.sure_ttl'),
        text: this.$t('common.warn.sure_text'),
        accept: () => {
          this.$vs.loading({ color: 'primary' })
          this.deleteCategory(category.id).then(() => {
            this.list()
            this.$vs.loading.close()
          })
        }
      })
    },
    save() {
      if (!this.category.id) {
        this.$vs.loading({ color: 'primary' })
        this.saveCategory(this.category).then(res => {
          if (!res.body || !res.body.success) {
            this.$vs.loading.close()
            return this.$vs.dialog({
              color: 'danger',
              title: this.$t('common.error.title'),
              text: this.$t('common.error.text')
            })
          }

          this.$vs.notify({
            title: this.$t('common.success.title'),
            text: this.$t('common.success.text'),
            color: 'success'
          })

          this.category = res.body.category
          this.list()
          this.closeEdition()
          setTimeout(this.$vs.loading.close, 1000)
        })
      } else {
        this.$vs.loading({ color: 'primary' })
        this.updateCategory(this.category).then(res => {
          if (!res.body || !res.body.success) {
            this.$vs.loading.close()
            return this.$vs.dialog({
              color: 'danger',
              title: this.$t('common.error.title'),
              text: this.$t('common.error.text')
            })
          }

          this.$vs.notify({
            title: this.$t('common.success.title'),
            text: this.$t('common.success.text'),
            color: 'success'
          })

          this.category = res.body.category
          this.list()
          this.closeEdition()
          setTimeout(this.$vs.loading.close, 1000)
        })
      }
    },
    uploaded(event) {
      const body = JSON.parse(event.currentTarget.response)

      this.category.avatar = body.avatar
      this.save()
    },
    list() {
      this.listCategories().then(res => {
        if (!res.body || !res.body.success) {
          this.$vs.loading.close()
          return this.$vs.dialog({
            color: 'danger',
            title: this.$t('common.error.title'),
            text: this.$t('common.error.text')
          })
        }

        this.categories = res.body.categories
        this.$vs.loading.close()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vs-button {
  margin: 0 5px;
}
.vs-list {
  margin: 20px auto;
}
.input-name {
  width: 100%;
}
.uploader {
  width: 90%;
}
.save {
  display: inline-block !important;
  text-align: right;
}
</style>

<style lang="scss">
.uploader {
  .con-input-upload {
    height: 50px;
  }
  button {
    position: absolute;
    right: 10px;
  }
}
.category-avatar{
  width: 100px;
  margin-right: 20px;
  border-radius: 10px; 
}
</style>
